/**
 * Public barrel export for the AddPlayersSearchResults organism (SE-6948).
 * @module features/player-kanban/components/organisms/AddPlayersSearchResults
 */
export { default } from "./AddPlayersSearchResultsContainer";
export type { AddPlayersSearchResultsContainerProps } from "./AddPlayersSearchResultsContainer";
